import React from 'react'

const WHITE = '#FFF'

const useSetBackgroundColor = (color: string) => {
  const initialBackgroundColor = React.useRef('')

  React.useEffect(() => {
    initialBackgroundColor.current = document.body.style.backgroundColor || WHITE

    document.body.style.backgroundColor = color

    return () => {
      document.body.style.backgroundColor = initialBackgroundColor.current
    }
  }, [])
}

export default useSetBackgroundColor
